/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileExe = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M13.188 12.895H11v1.118h1.986v.91H11v1.166h2.256V17H9.924v-5.017h3.263zm2.764.822 1.008-1.734h1.187l-1.476 2.433L18.223 17h-1.236l-1.119-1.897L14.794 17h-1.188l1.547-2.602-1.47-2.415h1.235zm6.083-.822h-2.187v1.118h1.987v.91h-1.987v1.166h2.257V17h-3.333v-5.017h3.263z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileExe as FileExe };
